import Vue from "vue";

import settings from "./components/Settings.vue";
import personal from "./components/Personal.vue";
import individual from "./components/AddIndividual.vue";
import entity from "./components/AddEntity.vue";
import entitynew from "./components/AddEntityNew.vue";
import declarers from "./components/Declarers.vue";
import declarer from "./components/AddDeclarer.vue";
import notificationsettings from "./components/NotificationSettings.vue";

var settingsComponent = document.getElementById('settings');
var personalComponent = document.getElementById('personal');
var entityComponent = document.getElementById('entity');
var entityNewComponent = document.getElementById('entitynew');
var individualComponent = document.getElementById('individual');
var declarersComponent = document.getElementById('declarers');
var declarerComponent = document.getElementById('declarer');
var notificationsettingsComponent = document.getElementById('notificationsettings');



if (typeof (settingsComponent) != 'undefined' && settingsComponent != null) {

    new Vue({
        el: "#settings",
        components: { settings }
    });
}

if (typeof (notificationsettingsComponent) != 'undefined' && notificationsettingsComponent != null) {

    new Vue({
        el: "#notificationsettings",
        components: { notificationsettings }
    });
}

if (typeof (personalComponent) != 'undefined' && personalComponent != null) {
    new Vue({
        el: "#personal",
        components: { personal }
    });
}

if (typeof (declarersComponent) != 'undefined' && declarersComponent != null) {
    new Vue({
        el: "#declarers",
        components: { declarers }
    });
}

if (typeof (entityComponent) != 'undefined' && entityComponent != null) {
    new Vue({
        el: "#entity",
        components: { entity }
    });
}

if (typeof (entityNewComponent) != 'undefined' && entityNewComponent != null) {
    new Vue({
        el: "#entitynew",
        components: { entitynew }
    });
}

if (typeof (declarerComponent) != 'undefined' && declarerComponent != null) {
    new Vue({
        el: "#declarer",
        components: { declarer }
    });
}

if (typeof (individualComponent) != 'undefined' && individualComponent != null) {
    new Vue({
        el: "#individual",
        components: { individual }
    });
}


// WEBPACK FOOTER //
// ./Scripts/app/profiles/profiles.js